import DesktopAccountSupplyAndBorrow from "./DesktopAccountSupplyAndBorrow";

export default DesktopAccountSupplyAndBorrow;
